import { useEffect, useState } from 'react';
import { clientDataService } from '@sky-distribution/gp-onboarding-client-data-service';
import { Contact } from '@sky-distribution/adapter-core-pc-rest-interfaces/core/rest/v2/Policy.type';
import { getSearchParams } from '../route';
import { getEngineerData } from './getEngineerData';

export const useEngineerData = () => {
  const searchParams = getSearchParams();
  const token = searchParams.get('token');
  const [engineerData, setEngineerData] = useState<Contact>({});

  useEffect(() => {
    if (token) {
      clientDataService
        .getEngineerData(token)
        .then((response: unknown) => setEngineerData(getEngineerData(response)))
        .catch((e) => console.log(e));
    }
  }, [token]);

  return { engineerData };
};
